import { Box, Grid, Skeleton, Typography } from '@mui/material';
import { CourseCard } from '@/components/partial/course-card';
import { BaseDialog } from '@/components/shared/base-dialog';
import { useRecommendedActivities } from '@/data/recommendation/recommended-activities';
import type { Course } from '@/models/catalog/course';

interface RecommendedCoursesDialogProps {
  activityId: string;
  onClose: () => void;
  onSave?: (course: Course) => void;
}

const Loading = () => (
  <Grid container spacing={2} mb={2}>
    {[...Array(2)].map((_, index) => (
      <Grid size={{ xs: 12, sm: 6 }} key={index}>
        <Skeleton key={index} variant="rounded" height={200} />
      </Grid>
    ))}
  </Grid>
);

const EmptyState = () => (
  <Box>
    <Typography variant="h3" gutterBottom>
      Não foi possível carregar os cursos
    </Typography>
    <Typography>
      Ocorreu um problema ao buscar as recomendações. Tente novamente mais
      tarde, ou explore outros cursos.
    </Typography>
  </Box>
);

export const RecommendedCoursesDialog = ({
  activityId,
  onClose,
  onSave,
}: RecommendedCoursesDialogProps) => {
  const { recommendedActivity, isFetching } = useRecommendedActivities({
    activityId,
  });

  const courses =
    recommendedActivity?.activity_based_course?.catalog_courses || [];

  const handleSave = (course: Course) => {
    onSave?.(course);
    onClose();
  };

  return (
    <BaseDialog
      open
      onClose={onClose}
      title="Incluir curso"
      fullWidth
      maxWidth="md"
    >
      <Typography mb={2}>
        Confira as recomendações de cursos e selecione aquele que melhor se
        encaixa no seu plano.
      </Typography>
      {isFetching && <Loading />}
      {!isFetching && !courses?.length && <EmptyState />}
      <Grid container spacing={2}>
        {!isFetching &&
          courses?.length > 0 &&
          courses.map((course) => (
            <Grid size={{ xs: 12, sm: 6 }} key={course.id}>
              <CourseCard data={course} onToggle={handleSave} />
            </Grid>
          ))}
      </Grid>
    </BaseDialog>
  );
};
